import { render, staticRenderFns } from "./TeacherServiceDetail.vue?vue&type=template&id=1c42888f&scoped=true"
import script from "./TeacherServiceDetail.vue?vue&type=script&lang=js"
export * from "./TeacherServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./TeacherServiceDetail.vue?vue&type=style&index=0&id=1c42888f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c42888f",
  null
  
)

export default component.exports